import { IEmptyObject } from "@Components/shared/types";
import Result from "@Core/Result";
import { ServiceBase } from "@Core/ServiceBase";
import { INotificationModel, INotificationPayload } from "@Models/INotificationPayload";

export default class NotificationService extends ServiceBase {
    public async getNotifications(userId: string): Promise<Result<INotificationModel[]>> {
        return await this.requestJson<INotificationModel[]>({
            url: `/api/Notification/Get/${userId}`,
            method: "GET",
        });
    }

    public async setNotificationViewed(notificationsId: string): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: `/api/Notification/SetViewed/${notificationsId}`,
            method: "PUT",
        });
    }

    public async setNotificationUnread(notificationsId: string): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: `/api/Notification/SetUnread/${notificationsId}`,
            method: "PUT",
        });
    }

    public async setNotificationDeleted(notificationsId: string): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: `/api/Notification/Remove/${notificationsId}`,
            method: "PUT",
        });
    }

    public async commonNotificationAction(
        method: "DELETE" | "PATCH" | "POST" | "PUT",
        url: string
    ): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: `/api/${url}`,
            method: method,
        });
    }

    public async createPayload(
        userId: string,
        payloadType: string,
        entityId: string
    ): Promise<Result<INotificationPayload>> {
        return await this.requestJson({
            url: `/api/Notification/CreatePayload/${userId}?payload-type=${payloadType}&entity=${entityId}`,
            method: "POST",
        });
    }

    public async create(userId: string, model: INotificationModel): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: `/api/Notification/Create/${userId}`,
            method: "POST",
            data: model,
        });
    }
}
